import { type ReactElement, type ReactNode } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface IContentWrapperProps {
  children: ReactNode;
  className?: string;
}

const ContentWrapper = ({ children, className }: IContentWrapperProps): ReactElement => (
  <div className={classNames(styles.content, className)}>
    {children}
  </div>
);

export default ContentWrapper;
